import type { StickerIllustrationProps } from '../Sticker';

export const PicturesStickerIllustration = ({ size }: StickerIllustrationProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 91 91"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="path-1-outside-1_9452_185"
      maskUnits="userSpaceOnUse"
      x="0.0515137"
      y="2.30151"
      width="91"
      height="86"
      fill="black"
    >
      <rect fill="white" x="0.0515137" y="2.30151" width="91" height="86" />
      <path d="M50.4686 8.3972C51.6586 8.0397 52.9128 8.71502 53.2704 9.90501L56.9833 22.2595L83.5956 29.3913C84.7957 29.7131 85.508 30.947 85.1864 32.1472L72.201 80.6101C71.8794 81.8103 70.6454 82.5224 69.4452 82.2009L30.0087 71.6335L23.3895 73.6238C22.1995 73.9814 20.9444 73.306 20.5868 72.116L6.14733 24.0661C5.78971 22.8761 6.46415 21.6211 7.65417 21.2634L50.4686 8.3972Z" />
    </mask>
    <path
      d="M50.4686 8.3972C51.6586 8.0397 52.9128 8.71502 53.2704 9.90501L56.9833 22.2595L83.5956 29.3913C84.7957 29.7131 85.508 30.947 85.1864 32.1472L72.201 80.6101C71.8794 81.8103 70.6454 82.5224 69.4452 82.2009L30.0087 71.6335L23.3895 73.6238C22.1995 73.9814 20.9444 73.306 20.5868 72.116L6.14733 24.0661C5.78971 22.8761 6.46415 21.6211 7.65417 21.2634L50.4686 8.3972Z"
      fill="white"
    />
    <path
      d="M50.4686 8.3972L48.8502 3.01005L48.8498 3.01019L50.4686 8.3972ZM53.2704 9.90501L47.8834 11.5239L47.8834 11.524L53.2704 9.90501ZM56.9833 22.2595L51.5963 23.8785L52.4987 26.8812L55.5272 27.6928L56.9833 22.2595ZM83.5956 29.3913L85.0523 23.9582L85.0516 23.9581L83.5956 29.3913ZM85.1864 32.1472L79.7531 30.6913L79.7531 30.6914L85.1864 32.1472ZM72.201 80.6101L77.6344 82.0659L77.6344 82.0659L72.201 80.6101ZM69.4452 82.2009L67.9893 87.6342L67.9899 87.6344L69.4452 82.2009ZM30.0087 71.6335L31.4646 66.2002L29.9202 65.7864L28.389 66.2468L30.0087 71.6335ZM23.3895 73.6238L25.0084 79.0108L25.0092 79.0105L23.3895 73.6238ZM20.5868 72.116L15.1998 73.7348L15.1998 73.7348L20.5868 72.116ZM6.14733 24.0661L11.5343 22.4473L11.5343 22.4473L6.14733 24.0661ZM7.65417 21.2634L6.03531 15.8764L6.03509 15.8765L7.65417 21.2634ZM50.4686 8.3972L52.087 13.7844C50.2992 14.3214 48.419 13.3061 47.8834 11.5239L53.2704 9.90501L58.6574 8.28612C57.4066 4.12393 53.0181 1.75796 48.8502 3.01005L50.4686 8.3972ZM53.2704 9.90501L47.8834 11.524L51.5963 23.8785L56.9833 22.2595L62.3703 20.6406L58.6574 8.28606L53.2704 9.90501ZM56.9833 22.2595L55.5272 27.6928L82.1395 34.8246L83.5956 29.3913L85.0516 23.9581L58.4393 16.8262L56.9833 22.2595ZM83.5956 29.3913L82.1389 34.8244C80.3388 34.3418 79.2707 32.4917 79.7531 30.6913L85.1864 32.1472L90.6197 33.6031C91.7453 29.4023 89.2525 25.0844 85.0523 23.9582L83.5956 29.3913ZM85.1864 32.1472L79.7531 30.6914L66.7677 79.1543L72.201 80.6101L77.6344 82.0659L90.6197 33.603L85.1864 32.1472ZM72.201 80.6101L66.7677 79.1542C67.2506 77.352 69.102 76.2857 70.9004 76.7674L69.4452 82.2009L67.9899 87.6344C72.1889 88.759 76.5083 86.2686 77.6344 82.0659L72.201 80.6101ZM69.4452 82.2009L70.9011 76.7676L31.4646 66.2002L30.0087 71.6335L28.5528 77.0668L67.9893 87.6342L69.4452 82.2009ZM30.0087 71.6335L28.389 66.2468L21.7698 68.237L23.3895 73.6238L25.0092 79.0105L31.6283 77.0203L30.0087 71.6335ZM23.3895 73.6238L21.7706 68.2368C23.5571 67.6999 25.4378 68.7134 25.9738 70.4971L20.5868 72.116L15.1998 73.7348C16.4511 77.8986 20.8418 80.2629 25.0084 79.0108L23.3895 73.6238ZM20.5868 72.116L25.9738 70.4971L11.5343 22.4473L6.14733 24.0661L0.760318 25.685L15.1998 73.7348L20.5868 72.116ZM6.14733 24.0661L11.5343 22.4473C12.0701 24.2302 11.0604 26.1132 9.27325 26.6504L7.65417 21.2634L6.03509 15.8765C1.8679 17.1289 -0.490731 21.522 0.76033 25.685L6.14733 24.0661ZM7.65417 21.2634L9.27303 26.6504L52.0875 13.7842L50.4686 8.3972L48.8498 3.01019L6.03531 15.8764L7.65417 21.2634Z"
      fill="white"
      mask="url(#path-1-outside-1_9452_185)"
    />
    <rect
      x="38.24"
      y="17.2383"
      width="49.2056"
      height="54.6729"
      rx="2.25"
      transform="rotate(15 38.24 17.2383)"
      fill="#FADD99"
    />
    <rect
      x="43.0723"
      y="25.6083"
      width="35.5374"
      height="36.9042"
      rx="2.25"
      transform="rotate(15 43.0723 25.6083)"
      fill="#99C8DC"
    />
    <mask id="mask0_9452_185" maskUnits="userSpaceOnUse" x="34" y="26" width="43" height="44">
      <rect
        x="43.0723"
        y="25.6083"
        width="35.5374"
        height="36.9042"
        rx="2.25"
        transform="rotate(15 43.0723 25.6083)"
        fill="#99C8DC"
      />
    </mask>
    <g mask="url(#mask0_9452_185)">
      <path d="M67.3945 72.1434L41.4216 25.1661L31.4172 62.5033L67.3945 72.1434Z" fill="#66ADCB" />
    </g>
    <rect
      x="5.5"
      y="21.9116"
      width="49.2056"
      height="54.6729"
      rx="2.25"
      transform="rotate(-16.7265 5.5 21.9116)"
      fill="#FDF4DD"
    />
    <rect
      x="14.012"
      y="26.4896"
      width="35.5374"
      height="36.9042"
      rx="2.25"
      transform="rotate(-16.7265 14.012 26.4896)"
      fill="#DDEDF4"
    />
    <mask id="mask1_9452_185" maskUnits="userSpaceOnUse" x="14" y="16" width="45" height="46">
      <rect
        x="14.012"
        y="26.4896"
        width="35.5374"
        height="36.9042"
        rx="2.25"
        transform="rotate(-16.7265 14.012 26.4896)"
        fill="#DDEDF4"
      />
    </mask>
    <g mask="url(#mask1_9452_185)">
      <path d="M59.1707 53.2807L12.3752 26.9816L23.5001 64.0004L59.1707 53.2807Z" fill="#99C8DC" />
    </g>
    <mask id="mask2_9452_185" maskUnits="userSpaceOnUse" x="14" y="16" width="45" height="46">
      <rect
        x="14.012"
        y="26.4896"
        width="35.5374"
        height="36.9042"
        rx="2.25"
        transform="rotate(-16.7265 14.012 26.4896)"
        fill="#DDEDF4"
      />
    </mask>
    <g mask="url(#mask2_9452_185)">
      <circle
        cx="36.5056"
        cy="38.7549"
        r="8.4604"
        transform="rotate(-15 36.5056 38.7549)"
        fill="#0076A8"
      />
      <path
        d="M39.1271 44.6443C44.5097 43.2021 50.0424 46.3963 51.4846 51.7789L58.0132 76.144L38.5212 81.3669L31.9925 57.0018C30.5503 51.6192 33.7446 46.0865 39.1271 44.6443Z"
        fill="#0076A8"
      />
    </g>
    <path
      d="M72.0148 2.20264C72.7397 0.243745 75.5103 0.243747 76.2352 2.20264L77.1083 4.56233C77.3362 5.1782 77.8218 5.66378 78.4377 5.89167L80.7974 6.76483C82.7563 7.48969 82.7563 10.2603 80.7974 10.9852L78.4377 11.8583C77.8218 12.0862 77.3362 12.5718 77.1083 13.1877L76.2352 15.5474C75.5103 17.5063 72.7397 17.5063 72.0148 15.5474L71.1417 13.1877C70.9138 12.5718 70.4282 12.0862 69.8123 11.8583L67.4526 10.9852C65.4937 10.2603 65.4937 7.48969 67.4526 6.76483L69.8123 5.89167C70.4282 5.66378 70.9138 5.1782 71.1417 4.56233L72.0148 2.20264Z"
      fill="white"
    />
  </svg>
);
